import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Helper to validate if a string is a valid HTTP/HTTPS URL and not a placeholder
const isValidUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  return (url.startsWith('http://') || url.startsWith('https://')) && !url.includes('your_supabase_url');
};

const isValidKey = (key) => {
  if (!key || typeof key !== 'string') return false;
  return key.length > 0 && !key.includes('your_supabase_anon_key');
};

// Only create the client if we have valid, real credentials
export const supabase = (isValidUrl(supabaseUrl) && isValidKey(supabaseAnonKey)) 
  ? createClient(supabaseUrl, supabaseAnonKey) 
  : null;